import 'slick-carousel'
import 'svgxuse'
import '../plugins/scrollevent'
import '../plugins/googlemap'
import '../plugins/pagescroll'
import style from '../json/mapstyle.json'

const [w,d,l] = [window,document,window.location]

export default function HOME() {
  const init = () => {

    $('[data-plugin="slider"]').slick({
      fade: true,
      cssEase: 'ease-in-out',
      autoplay: true
    })

    // グローバルメニューをスクロール量で表示する
    $.scrollspy({
      trigger: (w.innerHeight * 0.6),
      onBefore(/* pos */) {
        $('.p-header').addClass('is-hidden');
        $('.p-mainvisual__overlay').removeClass('is-hidden');
      },
      onAfter() {
        $('.p-header').removeClass('is-hidden');
        $('.p-mainvisual__overlay').addClass('is-hidden');
      }
    })

    // セクションプラグイン
    {
      const sections = d.querySelectorAll('[data-plugin="section"]')
      const sectionInit = section => {
        const section_body = section.querySelector('[data-role="body"]')
        const section_toggle = section.querySelectorAll('[data-role="toggleCover"]')
        section_body.style.display = 'none'
        Array.prototype.forEach.call(section_toggle, tgl=>{
          tgl.addEventListener('click',() => sectionClick(section,section_body))
        })
      }
      const sectionClick = (section,section_body) => {
        if( section.classList.contains('active') ){
          $('body,html').animate({scrollTop: $(section).offset().top - 60 }, 300,'easeInOutExpo',()=>{
            $(section_body).slideUp(600,'linear')
            section.classList.remove('active')
          })
        }else{
          $('body,html').animate({scrollTop: $(section).offset().top - 60 }, 300,'easeInOutExpo',()=>{
            section.classList.add('active')
          })
          $(section_body).slideDown(800,'linear')
        }
      }
      Array.prototype.forEach.call(sections, sectionInit)
    }

    // map init
    {
      const map_keys = {
        'local': 'AIzaSyCTB3MSMYkTjSz6l30k79XflmmL_FcOxkg', //development
        'www.mitsuyasu.co.jp': 'AIzaSyDEROgB2dru4iOJAyLiHZKKvWaS-P8ZWbA', //production
        'mitsuyasu.co.jp': 'AIzaSyDEROgB2dru4iOJAyLiHZKKvWaS-P8ZWbA', //production
        'mitsuyasu.dev.goopy.mp': 'AIzaSyDEROgB2dru4iOJAyLiHZKKvWaS-P8ZWbA' //test
      }
      $.getScript(`https://maps.googleapis.com/maps/api/js?key=${(map_keys[l.host]||map_keys['local'])}`)
      .done(() => {
        $('[data-plugin="googlemap"]').googlemap({
          styleObj: {name: 'mapstyle', style }
        })
      })
    }

    // 謎の印刷ボタン
    {
      const btns = d.querySelectorAll('[data-plugin="print"]')
      Array.prototype.forEach.call(btns, btn => {
        btn.addEventListener('click',()=> w.print())
      })
    }

  }

  d.addEventListener('DOMContentLoaded',init)
}